export { default as Alternate } from "./Alternate"
export { default as Base } from "./Base"
export { default as Carousel } from "./Carousel"
export { default as LeadText } from "./LeadText"
export { default as Parallax } from "./Parallax"
export { default as Primary } from "./Primary"
export { default as Secondary } from "./Secondary"
export { default as SubTitle } from "./SubTitle"
export { default as Title } from "./Title"
